export default "__VITE_ASSET__DY1qTNSr__"